module.exports = Number.isNaN || function isNaN(a) {
	return a !== a;
};



//////////////////
// WEBPACK FOOTER
// ./~/es-abstract/helpers/isNaN.js
// module id = 657
// module chunks = 0